<template>
    <form class="container order-page" v-if="this.$store.state.settings.basket.basket.length > 0">
        <div class="order-page__order-data">
            <h3 class="order-page__title">{{ trans('Making an order') }}</h3>
            <div class="order-page__user-data">

                <div class="input-wrapper">
                    <span class="input-wrapper__title ">{{ trans('First Name') }}, {{ trans('Last Name') }}</span>
                    <input v-model="name"
                           :class="checkName ? 'border-red':''"
                           name="name"
                           type="text" :placeholder=" this.trans( 'First Name, Last Name') "
                           class="input-element input-wrapper__element-inp   ">

                </div>


                <div class="input-wrapper">

                    <span class="input-wrapper__title">{{ trans('Telephone') }} </span>
                    <vue-tel-input v-model="phone"
                                   mode="international"
                                   :class="checkPhone ? 'border-red':''"
                                   :inputOptions="{placeholder:this.trans('Enter a phone number')}"
                                   :lang="this.$store.state.settings.lang"
                                   :defaultCountry="this.$store.state.settings.country.code"
                                   @validate="itiChange"


                    ></vue-tel-input>


                </div>
                <div class="input-wrapper">

                    <span class="input-wrapper__title">e-mail </span>
                    <input v-model="email"
                           :class="checkEmail ? 'border-red':''"
                           name="email"
                           type="text"
                           @change="checkEmailValid"
                           class="input-element input-wrapper__element-inp   ">

                </div>

                <div class="input-wrapper ">
                    <span class="input-wrapper__title">{{ trans('Country') }} </span>
                    <input v-model="country"
                           :class="checkCountry ? 'border-red':''"
                           @keyup="debounceSearchCountry(500)"
                           @focus="focusedCountry = true"
                           @blur="setFocusedCountry"
                           type="text"
                           class="search-input input-element input-wrapper__element-inp">
                    <ul v-if="countriesList.length > 0 && focusedCountry "

                        class="input-wrapper__suggestions input-city absolute">
                        <li v-for="country_ in countriesList" :key="country_.id" @click="setCountry(country_)"
                            class=" input-wrapper__suggestion city_click">
                            {{ country_[this.$store.state.settings.lang] }}
                        </li>
                    </ul>
                </div>


                <div class="input-wrapper ">
                    <span class="input-wrapper__title">{{ trans('City') }} </span>
                    <input v-model="city"
                           :class="checkCity ? 'border-red':''"
                           @focus="focusedCity = true"
                           @blur="setFocusedCity()"
                           @keyup="debounceSearchCity(500)"
                           type="text"
                           class="search-input input-element input-wrapper__element-inp">

                    <ul v-if="citiesList.length > 0 && focusedCity "

                        class="input-wrapper__suggestions input-city absolute">
                        <li v-for="city_ in citiesList" :key="city_.id" @click="setCity(city_)"
                            class=" input-wrapper__suggestion city_click">
                            {{ city_.name }} {{ city_.get_region?.name }}
                        </li>
                    </ul>
                </div>

                <div class="input-wrapper ">
                    <span class="input-wrapper__title">{{ trans('Region') }} </span>
                    <input v-model="region"
                           :class="checkRegion ? 'border-red':''"
                           @focus="focusedRegion = true"
                           @blur="setFocusedRegion"
                           @keyup="debounceSearchRegion(500)"
                           type="text"
                           class="search-input input-element input-wrapper__element-inp">
                    <ul v-if="regionList.length > 0 && focusedRegion "

                        class="input-wrapper__suggestions input-city absolute">

                        <li v-for="region_ in regionList" :key="region_.id" @click="setRegion(region_)"
                            class=" input-wrapper__suggestion city_click">
                            {{ region_.name }}
                        </li>
                    </ul>
                </div>

                <div class="input-wrapper" v-if="postal_codeShow">

                    <span class="input-wrapper__title">{{ trans('Postal code') }} </span>
                    <input v-model="postal_code"
                           :class="checkPostal_code ? 'border-red':''"
                           name="postal_code"
                           type="text"
                           class="input-element input-wrapper__element-inp   ">


                </div>

                <div class="input-wrapper" v-if="addressShow">

                    <span class="input-wrapper__title">{{ trans('Address') }} </span>
                    <input v-model="address"
                           :class="checkAddress ? 'border-red':''"
                           name="address"
                           type="text"
                           class="input-element input-wrapper__element-inp   ">


                </div>

                <div class="input-wrapper" v-if="apartmentShow">
                    <span class="input-wrapper__title">{{ trans('Apartments, suites, etc') }}.</span>
                    <input v-model="apartment"
                           name="apartment"
                           type="text" class="input-element input-wrapper__element-inp">
                </div>


                <div class="input-wrapper">
                    <span class="input-wrapper__title">{{ trans('Comment on the order') }}</span>
                    <textarea v-model="textarea"
                              rows="4" class="input-element input-wrapper__element-inp"></textarea>
                </div>
            </div>

            <Delivery ref="delivery" />
            <Payments :paymentMethods="paymentMethodsList" :defMethod="paymentMethod" ref="payments"/>

            <div class="checkbox">
                <div style="position: relative;">
                    <input v-model="subscribe"
                           class="checkbox__input" type="checkbox" name="subscribe_input" id="subscribe_input">
                    <label class="checkbox__label" for="subscribe_input"></label>
                </div>
                <span
                    class="checkbox__title">{{
                        trans('Subscribe to the news in which we tell you about our special events and current promotions')
                    }}</span>
            </div>

            <div class="order-page__footer" style="margin-bottom: 30px">

                <button @click.prevent="saveOrder" :disabled="saveOrderLoader || !termsAccepted"
                        :class="(saveOrderLoader || !termsAccepted) ? 'btn-submit_active' : ''" type="submit"
                        class="btn  order-page__create-btn btn-submit"><span>{{ trans('Place an order') }}</span>
                    <svg v-if="saveOrderLoader" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
                        <radialGradient id="a12" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
                            <stop offset="0" stop-color="#FFFFFF"></stop>
                            <stop offset=".3" stop-color="#FFFFFF" stop-opacity=".9"></stop>
                            <stop offset=".6" stop-color="#FFFFFF" stop-opacity=".6"></stop>
                            <stop offset=".8" stop-color="#FFFFFF" stop-opacity=".3"></stop>
                            <stop offset="1" stop-color="#FFFFFF" stop-opacity="0"></stop>
                        </radialGradient>
                        <circle transform-origin="center" fill="none" stroke="url(#a12)" stroke-width="15"
                                stroke-linecap="round" stroke-dasharray="200 1000" stroke-dashoffset="0" cx="100"
                                cy="100" r="70">
                            <animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="2"
                                              values="360;0" keyTimes="0;1" keySplines="0 0 1 1"
                                              repeatCount="indefinite"></animateTransform>
                        </circle>
                        <circle transform-origin="center" fill="none" opacity=".2" stroke="#FFFFFF" stroke-width="15"
                                stroke-linecap="round" cx="100" cy="100" r="70"></circle>
                    </svg>
                </button>
                <div v-if="this.$store.state.settings.site_id === 2" class="checkbox terms-chb">
                    <div style="position: relative;">
                        <input
                            v-model="termsAccepted"
                            class="checkbox__input"
                            type="checkbox"
                            name="terms_input"
                            id="terms_input"
                        >
                        <label
                            class="checkbox__label"
                            for="terms_input"
                        ></label>
                    </div>
                    <span class="checkbox__title">
                        By placing your order, you agree to our <a href="/public-offer">Terms & Conditions</a> and <a href="/refund">returns policies</a>
                    </span>
                </div>
            </div>

        </div>
        <div id="block_order-page__order-summary">
            <div class="order-page__order-summary">
                <h3 class="order-page__title">{{ trans('Your order') }}</h3>
                <div class="order-page__items-block">

                    <a class="cart-element__link order-page__basket-item" v-for="card in  cards"
                       :href="card.slug">
                        <img :src="card.img" class="order-page__basket-item-img" :alt="card.name">
                        <div class="order-page__basket-item-info">
                            <span class="cart-element__title">{{ card.name }}</span>
                            <div class="cart-element__size">{{ trans("Size") }}
                                : <b>{{ card.size }}</b>
                            </div>
                            <template v-if="card.price_old_str">
                                <span class="cart-element__price product__sale-price"
                                      style="margin-right: 8px">{{ card.price_str }} {{ this.signs }}</span>
                                <span class="cart-element__price  product__old-price ">{{ card.price_old_str }} {{
                                        this.signs
                                    }}</span>
                            </template>

                            <span class="cart-element__price  product__text-def " v-if="!card.price_old_str">{{
                                    card.price_str
                                }} {{ this.signs }}</span>


                        </div>
                    </a>

                </div>
                <Loading v-if="loading"/>
                <table class="order-page__price-table" v-if="!loading">
                    <tbody>

                    <tr>
                        <td>{{ trans("Total Purchase Amount") }}:</td>

                        <td class="order-page__price-table-value-cell">{{ orderingData.amountWithoutDiscountExcludingDeliveryStr }} {{ signs }}</td>
                    </tr>


                    <tr v-if="discount > 0">
                        <td>{{ trans("Discount") }}:</td>
                        <td class="order-page__price-table-value-cell">{{ orderingData.amountOfDiscountStr }} {{ signs }}</td>
                    </tr>

                    <tr v-if="total_delivery > 0">
                        <td>{{ trans("Delivery") }}:</td>
                        <td class="order-page__price-table-value-cell">{{ orderingData.deliveryPriceStr }} {{ signs }}</td>
                    </tr>

                    <tr class="order-page__total-row">
                        <td>{{ trans('Total') }}:</td>
                        <td class="order-page__price-table-value-cell">{{ orderingData.amountTotalStr }} {{ signs }}</td>

                    </tr>


                    </tbody>
                </table>

                <div class="order-page__protected-info">
                    <img src="https://batnorton.com/img/sheild.svg" alt="payment protection"
                         class="order-page__protected-info-img">
                    <span class="order-page__protected-info-label">{{
                            trans("We guarantee 100 % safety of purchases")
                        }}</span>
                </div>

            </div>

        </div>


    </form>
    <div v-else class="container">
        <h2>{{ trans("There is nothing in the basket") }} </h2>
    </div>
    <Viewed></Viewed>
</template>

<script>

import {VueTelInput} from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
import Loading from '../../components/loading.vue'
import Delivery from '../../components/Block/deliveries.vue'
import Payments from '../../components/Block/payments.vue'

import Viewed from '../../components/viewed.vue'
import { addPaymentInfo, addShippingInfo, beginCheckout } from '../../services/ga4Ecommerce.js'

export default {
    components: {
        VueTelInput, Delivery, Payments, Loading, Viewed
    },
    name: "basket-make",
    data() {
        return {
            timeoutId: null,
            loading: true,
            promo: null,
            promo_cond: {},
            orderingData: {},
            amount: 0,
            discount: 0,
            total_delivery: 0,
            total: 0,
            signs: this.$store.state.settings.currency_sing,

            phoneIsValid: false,
            settingFields: this.$store.state.settings.fieldsFormSite[this.$store.state.settings.site_id],

            name: '',
            checkName: false,

            phone: '',
            checkPhone: false,

            email: '',
            checkEmail: false,

            country: '',
            country_id: '',
            checkCountry: false,
            focusedCountry: false,
            countriesList: [],


            city: '',
            city_id: null,
            focusedCity: false,
            checkCity: false,
            citiesList: [],

            region: '',
            region_id: null,
            focusedRegion: false,
            checkRegion: false,
            regionList: [],

            postal_code: '',
            postal_codeShow: true,
            checkPostal_code: false,

            address: '',
            addressShow: true,
            checkAddress: false,

            apartment: '',
            apartmentShow: true,
            checkApartment: false,

            textarea: '',
            pvz: '',
            subscribe: true,
            termsAccepted: true,
            saveOrderLoader: false,
            deliveries: {},
            cards: [],
            paymentMethodsList: [],
            deliveriesMethod: '',
            paymentMethod: '',
            order_id: null,
            isSecretCardExists: false,
            delivery_price: null,
            ga4BeginCheckoutSent: false,
        }
    },
    methods: {
        checkEmailValid(){

            if (!this.validateEmail()) {
                this.checkEmail = true
            } else {
                this.checkEmail = false
            }
        },
        itiChange(object) {

            if (object.valid === true) {
                this.phoneIsValid = true;
                this.$store.state.settings.order.phone = object.number
                this.$store.state.settings.order.phone_formatted = object.formatted
                this.$store.state.settings.order.phone_countryCallingCode = object.countryCallingCode
                this.$store.state.settings.order.phone_countryCode = object.countryCode
                this.updateStorage(this.$store.state.settings)
            } else {
                this.phoneIsValid = false;
            }
        },
        validateEmail() {
            const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;
            return emailRegex.test(this.email)
        },
        setFields() {
            let lang = this.$store.state.settings.lang

            if (this.$store.state.settings.delivery_city?.name) {
                this.city = this.$store.state.settings.delivery_city.name
                this.city_id = this.$store.state.settings.delivery_city.id
                this.region = this.$store.state.settings.delivery_city.get_region?.name
                this.region_id = this.$store.state.settings.delivery_city.get_region?.id ?? null
                this.country = this.$store.state.settings.delivery_city.get_country?.[lang]
                this.country_id = this.$store.state.settings.delivery_city.get_country?.id ?? ''
            } else {
                this.country_id = this.$store.state.settings.country?.id ?? ''
            }

            this.checkName = this.settingFields.name
            this.checkPhone = this.settingFields.phone
            this.checkEmail = this.settingFields.email
            this.checkCountry = this.country ? false : this.settingFields.country
            this.checkCity = this.city ? false : this.settingFields.city
            this.checkRegion = this.region ? false : this.settingFields.region
            this.checkPostal_code = this.settingFields.postal_code
            this.checkAddress = this.settingFields.address
            this.checkApartment = this.settingFields.apartment

            if (this.city && this.country) {
                this.getDelivery()
            }
            if (this.$store.state.settings.order.name) {
                this.name = this.$store.state.settings.order.name
            }
            if (this.$store.state.settings.order.address) {
                this.address = this.$store.state.settings.order.address
            }
            if (this.$store.state.settings.order.apartment) {
                this.apartment = this.$store.state.settings.order.apartment
            }
            if (this.$store.state.settings.order.phone_formatted) {
                this.phone = this.$store.state.settings.order.phone_formatted
            }
            if (this.$store.state.settings.order.postal_code) {
                this.postal_code = this.$store.state.settings.order.postal_code
            }
            if (this.$store.state.settings.order.email) {
                this.email = this.$store.state.settings.order.email
            }

        },
        async getDelivery() {
            this._deliveryFetchInProgress = true
            this.$refs.delivery.loading = true
            this.loading = true
            const promo = this.getStoredPromo()
            try {
                const deliveryParams = this.setParam({
                        country_id: this.country_id,
                        region_id: this.region_id,
                        city_id: this.city_id,
                        country: this.country,
                        region: this.region,
                        city: this.city,
                        //cards: this.$store.state.settings.basket.basket,
                        user_id: this.$store.state.settings.user?.id,
                        guest_id: this.$store.state.settings.guest.id,
                    })
                this.appendVipDiscountParam(deliveryParams)
                if (promo?.code && promo?.promo_token) {
                    deliveryParams.promo = promo.code
                    deliveryParams.token = promo.promo_token
                }
                const { data } = await axios.get('/api/v1/get-delivery-basket', {
                    params: deliveryParams,
                })

                if (data.city) {
                    this.$refs.delivery.deliveries = data.deliveries
                    this.deliveries = data.deliveries
                    this.delivery_price = this.deliveries[this.deliveriesMethod]?.price_int ?? null
                    this.$store.state.settings.delivery_city = data.city
                    this.city_id = data.city.id
                    this.$refs.delivery.city_id = data.city.id

                    this.region = data.city.get_region?.name
                    this.region_id = data.city.get_region?.id
                    this.country = data.city.get_country[this.$store.state.settings.lang]
                    this.country_id = data.city.get_country.id

                } else {
                    this.checkCity = true
                }
            } catch (e) {
            } finally {
                await this.$nextTick()
                this._deliveryFetchInProgress = false
                if (this.$refs.delivery) {
                    this.$refs.delivery.loading = false
                }
                this.loading = false
                this.getOrdering()
            }
        },
        debounceSearchCountry(debounceDuration = 300) {

            if (this.$store.state.settings.fieldsFormSite[this.$store.state.settings.site_id].hints.country) {
                if (this.timeoutId !== null) {
                    clearTimeout(this.timeoutId);
                }
                this.timeoutId = setTimeout(_ => {
                    this.getCountry()

                }, debounceDuration);
            }

        },
        debounceSearchCity(debounceDuration = 300) {
            if (this.$store.state.settings.fieldsFormSite[this.$store.state.settings.site_id].hints.city) {
                this.city_id = ''
                this.region = ''
                this.region_id = ''
                if (this.timeoutId !== null) {
                    clearTimeout(this.timeoutId);
                }
                this.timeoutId = setTimeout(_ => {
                    this.getCity()

                }, debounceDuration);
            }

        },
        debounceSearchRegion(debounceDuration = 300) {
            if (this.$store.state.settings.fieldsFormSite[this.$store.state.settings.site_id].hints.region) {
                this.region_id = null

                if (this.timeoutId !== null) {
                    clearTimeout(this.timeoutId);
                }
                this.timeoutId = setTimeout(_ => {
                    this.getRegion()

                }, debounceDuration);
            }

        },
        setCountry(country) {

            this.country = country[this.$store.state.settings.lang]
            this.country_id = country.id
            this.focusedCountry = false

            this.city = ''
            this.city_id = null
            this.region = ''
            this.region_id = null
            this.countriesList = []
            this.citiesList = []
            this.regionList = []
        },
        setCity(city) {
            this.city = city.name
            this.city_id = city.id
            this.focusedCity = false

            this.country = city.get_country[this.$store.state.settings.lang]
            this.country_id = city.get_country.id

            this.region = city.get_region?.name
            this.region_id = city.get_region?.id
            this.$store.state.settings.delivery_city = city
            this.updateStorage(this.$store.state.settings)
            this.getDelivery()
            this.citiesList = []
            this.regionList = []
            this.countriesList = []
        },
        setRegion(region) {
            this.country = region.get_country[this.$store.state.settings.lang]
            this.country_id = region.get_country.id
            this.region = region.name
            this.region_id = region.id

            this.citiesList = []
            this.regionList = []
            this.countriesList = []
            if (this.$store.state.settings.delivery_city?.get_region?.id !== region.id) {
                this.getCheckCity()
            } else {
                this.getDelivery()
            }
        },
        setFocusedCountry() {
            setTimeout(() => {
                this.focusedCountry = false
                const raw = localStorage.getItem('countries')
                if (!raw) {
                    this.checkCountry = true
                    return
                }
                let list
                try {
                    list = JSON.parse(raw)
                } catch (e) {
                    this.checkCountry = true
                    return
                }
                if (!Array.isArray(list)) {
                    this.checkCountry = true
                    return
                }
                const countries = list.find(item => item.ru.toLowerCase() == this.country.toLowerCase() ||
                    item.en.toLowerCase() == this.country.toLowerCase() ||
                    item.de.toLowerCase() == this.country.toLowerCase() ||
                    item.es.toLowerCase() == this.country.toLowerCase() ||
                    item.fr.toLowerCase() == this.country.toLowerCase() ||
                    item.ja == this.country ||
                    item.ko == this.country ||
                    item.zh == this.country
                )
                if (countries) {
                    this.country = countries[this.$store.state.settings.lang]
                    this.country_id = countries.id
                } else {
                    this.checkCountry = true
                }

            }, 200)
        },
        setFocusedCity() {

            setTimeout(() => {
                this.focusedCity = false,
                    this.getDelivery()
            }, 200)
        },
        setFocusedRegion() {
            setTimeout(() => this.focusedRegion = false, 200)
        },
        async getRegion() {
            await axios.get('/api/v1/get-region-search', {
                params: this.setParam({
                    search: this.region,
                    country_id: this.country_id,
                })
            })
                .then(data => {

                    this.regionList = data.data


                }, err => {

                })
        },
        async getCity() {
            if (this.city.length > 2) {
                await axios.get('/api/v1/get-cities-search', {
                    params: this.setParam({
                        search: this.city,
                        country_id: this.country_id,
                    })
                })
                    .then(data => {

                        this.citiesList = data.data


                    }, err => {

                    })
            }

        },
        async getCheckCity() {

            await axios.get('/api/v1/get-city-check', {
                params: this.setParam({
                    city: this.city,
                    region: this.region,
                    region_id: this.region_id,
                    country_id: this.country_id,
                })
            })
                .then(data => {

                    if (data.data.status == 'success' && data.data.city.name.toLowerCase() == this.city.toLowerCase()) {
                        this.$store.state.settings.delivery_city = data.data.city
                        this.region = data.data.city.get_region?.name ?? this.region
                        this.region_id = data.data.city.get_region?.id ?? this.region_id
                        this.city = data.data.city.name
                        this.city_id = data.data.city.id
                        this.updateStorage(this.$store.state.settings)
                        this.getDelivery()
                    } else {
                        this.city = '';
                        this.city_id = '';
                    }


                }, err => {

                })
        },
        async getCountry() {
            if (this.country.length >= 3) {
                await axios.get('/api/v1/get-country-search', {
                    params: this.setParam({
                        search: this.country,
                    })
                })
                    .then(data => {
                        this.countriesList = data.data
                    })
            }
        },
        async getToken() {
            const promo = this.getStoredPromo()
            await axios.get('/api/v1/get-token', {
                params: this.setParam({
                    token: promo?.promo_token ?? localStorage.getItem('promo_token')
                })
            })
                .then(data => {
                    if (!data.data) {
                        this.$store.state.settings.promo = null
                    } else {
                        this.$store.state.settings.promo = this.getStoredPromo()
                    }
                })
        },
        async getOrdering(setPaymentMethod = true) {
            // Добавить флаг для предотвращения циклических обновлений
            if (this._gettingOrdering) return;
            this._gettingOrdering = true;
            const promo = this.getStoredPromo()
            const params = {};
            params.guest_id = this.$store.state.settings.guest.id
            params.delivery_method = this.deliveriesMethod
            params.payment_method = this.paymentMethod
            params.delivery_price = this.deliveries[this.deliveriesMethod]?.price_int ?? null
            const orderingPayload = this.setParam(params)
            if (promo?.code && promo?.promo_token) {
                orderingPayload.promo = promo.code
                orderingPayload.token = promo.promo_token
            }
            this.appendVipDiscountParam(orderingPayload)

            await axios.post('/api/v1/get-ordering', orderingPayload)
                .then(data => {
                    const d = data.data
                    this.orderingData = d
                    this.amount = d.amountWithoutDiscount
                    this.total_delivery = d.deliveryPrice
                    this.discount = d.amountOfDiscount
                    this.total = d.amountTotal
                    this.cards = d.cards
                    this.signs = d.sign
                    this.paymentMethodsList = d.paymentMethods
                    this.paymentMethod = d.selectedPayment
                    this.deliveriesMethod = d.selectedDelivery
                    this.trackGa4Checkout()
                    if (d.promo_clear) {
                        localStorage.removeItem('promo')
                        localStorage.removeItem('promo_token')
                        this.$store.state.settings.promo = null
                    }
                    if (d.promo) {
                        this.promo_cond = d.promo
                    }
                })
                .finally(() => {
                    this._gettingOrdering = false;
                })
        },
        saveOrder() {
            this.pvz = this.$store.state.settings.delivery_city?.pvz ?? null
            this.saveOrderLoader = true

            this.createOrder();
        },
        async createOrder() {
            const promo = this.getStoredPromo()
            const orderPayload = this.setParam({
                specials: [],
                site_id: this.$store.state.settings.site_id,
                guest_id: this.$store.state.settings.guest.id,
                user: this.$store.state.settings.user?.id,
                name: this.name,
                phone: this.phone,
                phone_country: this.$store.state.settings.order.phone_countryCallingCode,
                email: this.email,
                country: this.country,
                country_id: this.country_id,
                city: this.city,
                city_id: this.city_id,
                region: this.region,
                region_id: this.region_id,
                postal_code: this.postal_code,
                address: this.address,
                apartment: this.apartment,
                textarea: this.textarea,
                pvz: this.$store.state.settings.delivery_city?.pvz ?? null,
                subscribe: this.subscribe,
                delivery_method: this.deliveriesMethod,
                delivery_price: this.delivery_price,
                payment_method: this.paymentMethod,
                amount: this.orderingData.amountWithoutDiscount,
                discount: this.orderingData.amountOfDiscount,
                total_delivery: this.orderingData.deliveryPrice,
                total: this.orderingData.amountTotal,
            })
            if (promo?.code && promo?.promo_token) {
                orderPayload.promo = promo.code
                orderPayload.promo_token = promo.promo_token
            }
            this.appendVipDiscountParam(orderPayload)
            await axios.post('/api/v1/new-order', orderPayload)
                .then(data => {

                    if (data.data.status == 'error') {
                        this.$notify({
                            title: this.trans('Error'),
                            text: data.data.text,
                            type: 'error',
                        });
                        if (data.data.code === 'empty_basket') {
                            window.setTimeout(() => {
                                window.location.replace('/personal/orders/basket');
                            }, 1500);
                        }
                    }
                    if (data.data.status == 'success') {
                        this.$notify({
                            title: this.trans('Notification'),
                            text: data.data.text,
                            type: 'success',

                        });
                        this.order_id = data.data.order.id
                        this.saveOrderLoader = false
                        // console.log(this.promo)
                        localStorage.removeItem('promo_token')
                        localStorage.removeItem('promo')
                         window.location.href = '/personal/basket/thanks/'+data.data.order.thanks_id;
                    }


                }).then(() => {
                    this.saveOrderLoader = false

                })
                .catch(() => {
                    this.saveOrderLoader = false
                    this.$notify({
                        title: this.trans('Error'),
                        text: this.trans('Failed to place order. Please try again.'),
                        type: 'error',
                    })
                })

        },
        ga4Coupon() {
            return this.getStoredPromo()?.code || this.$store.state.settings.promo?.code || undefined
        },
        ga4ShippingTier() {
            const method = this.deliveriesMethod
            if (method === 'world_delivery') {
                return 'Duty & Tax Inclusive'
            }
            if (method === 'world_delivery_tax') {
                return 'Duty & Tax Exclusive'
            }
            return this.deliveries?.[method]?.name || method
        },
        ga4PaymentType() {
            if (this.paymentMethod === 'paypal') {
                return 'PayPal'
            }
            if (this.paymentMethod === 'stripe') {
                return 'Card'
            }
            return this.paymentMethod
        },
        trackGa4Checkout() {
            if (this.ga4BeginCheckoutSent || !this.cards?.length) {
                return
            }
            this.ga4BeginCheckoutSent = true
            beginCheckout(
                this.cards,
                this.orderingData?.amountTotal ?? this.total,
                this.$store.state.settings.currency,
                this.ga4Coupon()
            )
        },

    },
    beforeMount() {
        if (this.$store.state.settings.basket.basket.length > 0) {
            this._deliveryFetchInProgress = true
        }
    },
    mounted() {

        if (this.$store.state.settings.basket.basket.length > 0) {
            this.setFields()
            if (!(this.city && this.country)) {
                this._deliveryFetchInProgress = false
                this.getOrdering()
            }
        }
        if (this.$store.state.settings.site_id === 1  && import.meta.env.MODE === 'production') {
            _tmr.push({ type: 'reachGoal', id: 3290316, value: 6, goal: 'init_checkout'});
        }
    },
    watch: {
        name() {

            if (this.settingFields.name && this.name.length === 0) {
                this.checkName = true

            } else {
                this.checkName = false
            }
            this.$store.state.settings.order.name = this.name
            this.updateStorage(this.$store.state.settings)
        },
        phone() {
            if (this.settingFields.phone && this.phone.length === 0) {
                this.checkPhone = true
            } else {
                this.checkPhone = false
            }
            this.$store.state.settings.order.phone_field = this.phone
            this.updateStorage(this.$store.state.settings)
        },
        email() {
            if (this.settingFields.email && this.email.length === 0) {
                this.checkEmail = true
            } else {
                this.checkEmail = false
            }
            if (this.validateEmail()) {

                this.$store.state.settings.order.email = this.email
                this.updateStorage(this.$store.state.settings)
            } else {
                this.checkEmail = false
            }
        },
        country() {

            if (this.settingFields.country && this.country.length === 0) {
                this.checkCountry = true
            } else {
                this.checkCountry = false
            }

        },
        region() {

            if (this.settingFields.region && this.region.length === 0) {
                this.checkRegion = true
            } else {
                this.checkRegion = false
            }
        },
        city() {
                this.pvz = null
                if (this.$store.state.settings.delivery_city) {
                    this.$store.state.settings.delivery_city.pvz = null
                }
            if (this.settingFields.city && this.city.length === 0) {
                this.checkCity = true
            } else {
                this.checkCity = false
            }
        },
        postal_code() {

            if (this.settingFields.postal_code && this.postal_code.length === 0) {
                this.checkPostal_code = true
            } else {
                this.checkPostal_code = false
            }
            this.$store.state.settings.order.postal_code = this.postal_code
            this.updateStorage(this.$store.state.settings)
        },
        address() {

            if (this.settingFields.address && this.address.length === 0) {
                this.checkAddress = true
            } else {
                this.checkAddress = false
            }
            this.$store.state.settings.order.address = this.address
            this.updateStorage(this.$store.state.settings)
        },
        apartment() {

            if (this.settingFields.apartment && this.apartment.length === 0) {
                this.checkApartment = true
            } else {
                this.checkApartment = false
            }
            this.$store.state.settings.order.apartment = this.apartment
            this.updateStorage(this.$store.state.settings)
        },
        deliveriesMethod(newVal, oldVal) {
            if (newVal === oldVal) return;

            this.delivery_price = this.deliveries[this.deliveriesMethod]?.price_int ?? null;

            const dm = this.deliveriesMethod
            const isStorePickup = Array.isArray(this.deliveries?.stores)
                && this.deliveries.stores.some(s => String(s.id) === String(dm))
            const isLegacyStoreKey = typeof dm === 'string' && dm.indexOf('store') >= 0
            if (dm === 'cdek_pvz' || isStorePickup || isLegacyStoreKey) {
                this.addressShow  = false
                this.apartmentShow  = false
                this.postal_codeShow  = false
            }else{
                this.addressShow  = true
                this.apartmentShow  = true
                this.postal_codeShow  = true
            }
            if (!this._deliveryFetchInProgress) {
                this.getOrdering()
            }
            if (oldVal) {
                addShippingInfo(
                    this.cards,
                    this.orderingData?.amountTotal ?? this.total,
                    this.$store.state.settings.currency,
                    this.ga4ShippingTier(),
                    this.ga4Coupon()
                )
            }
        },
        paymentMethod(newVal, oldVal) {
            if (newVal === oldVal) return;
            if (!this._deliveryFetchInProgress) {
                this.getOrdering()
            }
            if (oldVal) {
                addPaymentInfo(
                    this.cards,
                    this.orderingData?.amountTotal ?? this.total,
                    this.$store.state.settings.currency,
                    this.ga4PaymentType(),
                    this.ga4Coupon()
                )
            }
        }
    }
}
</script>

<style scoped>
input:focus-within, textarea:focus-within {
    box-shadow: inset 0 1px 1px #00000013, 0 0 8px #66afe999;
    border-color: #66afe9
}

.border-red {
    box-shadow: inset 0 1px 1px #fbfbfb, 0 0 8px #db2719;

}

.absolute {
    position: absolute
}

input[type="number"]::-webkit-inner-spin-button, input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type="number"] {
    -moz-appearance: textfield;
}

textarea {
    resize: none;
}

.btn-submit svg {
    width: 24px;
}

.btn-submit {
    justify-content: center;
    display: flex;
    align-items: center;
    gap: 20px;
    font-weight: 550;
    font-size: 14px;
    line-height: 100%;
    height: 45px;
    text-align: center;
    text-transform: uppercase;
    border: 1px solid #000;
    color: #fff;
    background: #000;
    -webkit-transition: all ease .3s;
    -o-transition: all ease .3s;
    transition: all ease .3s;
}

.btn-submit:disabled {
    color: #fff;
    background: #646464;
    cursor: not-allowed;
}

.btn-submit:hover {
    color: #000;
    background: #fff;
    -webkit-transition: all ease .3s;
    -o-transition: all ease .3s;
    transition: all ease .3s
}

.btn-submit_active {
    color: #fff !important;
    background: #646464 !important;;
    cursor: not-allowed;
}
.terms-chb {
    margin-top: 20px;
}
.terms-chb a {
    color: black;
    text-decoration: underline;
}
</style>
